export default "/_next/static/chunks/fonts/Montserrat ExtraBold-2d63662d2107c9c277bcd25ffeb40a17.otf";